import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { addEmploymentStatuses, updateEmploymentStatuses } from '../../actions/userActions/employmentStatusAction'
import { Redirect, useLocation, useHistory } from 'react-router-dom';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import BodyLargeMedium from '../designSystem/BodyLargeMedium';
import { IconButton } from '@mui/material';
import Textarea from '../designSystem/TextArea';
import TextField from '../designSystem/TextField';
import empstatusicon from "../../assets/images/empstatusicon.svg";
import closeModal from "../../assets/images/closeModal.svg";
import { validateFields } from '../../utils/Validations';
import { Check, X } from 'lucide-react';
import CancelButton from '../subComponents/buttons/CustomCancelButton';
import PrimaryButton from '../subComponents/buttons/PrimaryButton';
import { t } from '../../locales/translate';
function AddEmploymentStatuses({ onClose, editData, onSave }) {

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const initialValues = { name: "", description: "", active: false };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  useEffect(() => {
    if (editData) {
      setFormValues(editData);
    }
  }, [editData]);

  const handleChange = (e) => {
    const { name, checked, type, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };
  const handletextChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const handleSave = async (e) => {
    e.preventDefault();
    const errors = validateFields(formValues, 'employeementstatus');
    setFormErrors(errors);

    if (Object.keys(errors).length > 0) return;

    if (editData) {
      await dispatch(updateEmploymentStatuses(formValues));
    } else {
      await dispatch(addEmploymentStatuses(formValues));
    }
    await onSave(formValues);
  };

  return (
    <>
      <div className="dynamicmodal-overlay">
        <div className="dynamicmodal-container">
          <div className="dynamicmodal-header mb-3">
            <div className="dynamicmodal-header-left">
              <div className="icon">
                <img src={empstatusicon} alt="empstatusicon" />
              </div>
              <div className="text">
                <h2 className="modalheading">
                  {editData ? "Edit Employment Status" : `${t("addEmploymentStatus")}`}
                </h2>
                <p className="modaldescription">
                  {t("addEmploymentStatusTip")}
                </p>
              </div>
            </div>
            <div className="dynamicmodal-header-right">
              <IconButton onClick={onClose}>
                <img src={closeModal} alt="" />
              </IconButton>
            </div>

          </div>


          <form onSubmit={handleSave}>
            <div className="dynamicmodal-body">

              <TextField
                name="name"
                label={`${t("name")} *`}
                type='text'
                value={formValues.name}
                onChange={handletextChange}
                placeholder={t("name")}
                error={formErrors.name}
              />

              <Textarea
                name="description"
                label={`${t("description")} *`}
                placeholder={t("description")}
                value={formValues.description}
                onChange={handletextChange}
                error={formErrors.description}
              />
              <div className=" mt-2 ml-0">
                <div
                  className="form-group"
                  style={{ display: "flex", alignItems: "flex-start" }}
                >
                  <input
                    name="active"
                    style={{ cursor: "pointer", height: "14px", width: "14px" }}
                    type="checkbox"
                    checked={formValues.active}
                    className="ml-1 mt-1"
                    onChange={handleChange}
                  />
                  <label
                    style={{ paddingLeft: "5px" }}
                    className="form-control-label"
                  >
                    <div style={{ padding: '2px' }}>
                    <p className="button-text">{t("active")}</p>
                    </div>
                  </label>
                </div>
              </div>
            </div>

            <div className="dynamicmodal-footer">
             <CancelButton
              onClick={onClose}
              text={t("cancel")}
              width={document.body.dir === "rtl" ? "119px" : ""}
              />
              <PrimaryButton
              text={t("save")}
              icon={Check}
              width={document.body.dir === "rtl" ? "119px" : ""}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default AddEmploymentStatuses
